'use strict';

angular.module('integrationModule', [
    'ngKomondorResourceView',
]);
